import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-price-from-document',
  templateUrl: './input-price-from-document.component.html',
  styleUrls: ['./input-price-from-document.component.less']
})
export class InputPriceFromDocumentComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterPrice(value: number): string {
    if (value === null || isNaN(value)) {
      return '';
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.PriceDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
